<!--component html goes here -->
<app-header></app-header>
<!-- <section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/foods.jpeg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
          <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> Foods </h4>
              </div>
          </div> 
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a>Foods</a></li>
              </ul>
          </nav>
      </div>
  </div>
</section> -->
<!--end section-->
<!-- <div class="position-relative">
        <div class="shape overflow-hidden text-color-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div> -->
  <!-- Hero Start -->
        <!-- Hero End -->
        <!-- Start Products -->
        <section class="bg-half" id="home">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="section-title text-center mb-4 pb-2">
                                <h4 ><span class="text-primary">Foods</span></h4>
                                <p class="text-muted para-desc mx-auto mb-0">All <span
                                        class="text-primary fw-bold">Foods</span> that may interest you around the world</p>
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <div class="row align-items-center">
                        <div class="col-lg-9 col-md-7">
                            <div class="section-title">
                                <h5 class="mb-0">Foods Results</h5>
                        </div>
                    </div><!--end col-->
                        <div *ngIf="modelObject" class="col-lg-3 col-md-5 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div class="d-flex justify-content-md-between align-items-center">
                                <div class="form custom-form">
                                    <div class="mb-0">
                                        <select  placeholder="Selecte Country" [(ngModel)]="modelObject.countryId" (change)="getByCountry()" class="form-select form-control" aria-label="Default select example" id="Sortbylist-job">
                                            <option [value]="0">All</option>
                                            <option  *ngFor="let data of CountriesList" [value]="data.id">{{data.nameEn}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
                    <div class="row">
                        <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2" *ngFor="let data of rows">
                            <div class="card nft nft-item nft-primary rounded shadow overflow-hidden">
                                <div class="nft-image position-relative overflow-hidden">
                                       <img src="{{data.images}}" height="200px" width="100%" class="item-img"  alt="">
                                    <div class="overlay"></div>
                                    <div class="bid-btn p-3 text-center">
                                        <a routerLink="/food-details/{{data.id}}" class="btn btn-pills"><i class="mdi mdi-gavel fs-6 me-2"></i>more</a>
                                </div>
                                    <div class="position-absolute top-0 start-0 m-2">
                                        <a ><img src="{{data.images}}" height="200px" width="100%" class="avatar avatar-sm-sm rounded-pill shadow-md" alt=""></a>
                                </div>
                                    <div class="position-absolute top-0 end-0 m-2">
                                        <ul class="label list-unstyled mb-0">
                                            <li><a href="javascript:void(0)" class="badge badge-link rounded-pill bg-success">{{data.countryNameEn}}</a></li>
                                    </ul>
                                </div>
                            </div>
                                <div class="card-body p-3">
                                    <a routerLink="/food-details/{{data.id}}" class="h5 title text-dark">{{data.nameEn}}</a>
                                    <div class="d-flex align-items-center justify-content-between mt-2">
                                        <span class="text-muted">
                                            <ngb-rating [max]="5" [(rate)]="data.averageStar" [readonly]="true" style="font-size: 25px;">
                                        </ngb-rating>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->
                        <!-- PAGINATION START -->
                        <div class="col-12 mt-4 pt-2">
                            <ul class="pagination justify-content-center mb-0">
                                <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous"><i class="mdi mdi-arrow-left"></i> Prev</a></li>
                                <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                                <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                                <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                                <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next <i class="mdi mdi-arrow-right"></i></a></li>
                        </ul>
                    </div><!--end col-->
                        <!-- PAGINATION END -->
                </div><!--end row-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End Products -->

        <!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
  <!-- Back to top -->
